/* eslint-disable class-methods-use-this */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CoreModule } from '../core.module';
import { OrganizationInterface } from 'src/app/plasma-ui-common/interfaces/organization.interface';

@Injectable({
  providedIn: CoreModule,
})
export class OrganizationService {
  public organizations$: Observable<OrganizationInterface[]> = of([]);

  public async getUserOrgs(userId: string, synlabId: string): Promise<OrganizationInterface[]> {
    console.log(userId, synlabId);
    return [];
  }

  public doSaveOrgId(orgId: string) {
    console.log(this, orgId);
  }

  public async getUserSessionOrg(): Promise<OrganizationInterface> {
    return of(null).toPromise();
  }
}
